import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchDataGroup,
  fetchId,
  fetchIdNoloading,
  fetchParam,
  selectDataGroup,
  selectDataParam,
  selectId,
  selectLoading,
} from "./paramSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  encryptData,
  checkEmptyFields,
  showDialog,
  paramsMasterAll,
  setOptionsMaster,
  decryptData,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";

export const ParamCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectId);
  const dataGroup = useSelector(selectDataGroup);
  const { id } = useParams();

  const [groupId, setGroupId] = useState("");
  const [refParam, setRefParam] = useState("");
  const [code, setCode] = useState("");
  const [value, setValue] = useState("");
  const [displayOrder, setDisplayOrder] = useState("");
  const [optionParam, setOptionParam] = useState([]);

  const paramsId = {
    param_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
      await dispatch(fetchDataGroup({ ...paramsMasterAll }));
    }
    fetchMyAPI();
  }, [dispatch]);
  useEffect(() => {
    if (dataGroup.length > 0) {
      setOptionsMaster(
        dataGroup,
        setOptionParam,
        "param_group_id",
        "param_group_name"
      );
    }
  }, [dataGroup]);

  useEffect(() => {
    if (dataId) {
      setGroupId(dataId.param_group_id);
      setCode(dataId?.param_code);
      setValue(dataId?.param_value);
      setDisplayOrder(dataId?.display_order);
      setRefParam(dataId.ref_param_id);
    }
  }, [dataId]);

  const handleSave = async () => {
    const fields = [
      { value: code, message: "input Param Code", valid: true },
      { value: value, message: "input Param value", valid: true },
      { value: groupId, message: "input Param Gruop", valid: true },
      { value: displayOrder, message: "input Display Order", valid: true },
    ];
    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }
    const params = {
      param_id: id,
      param_group_id: groupId,
      param_code: code,
      param_value: value,
      display_order: displayOrder,
      ref_param_id: refParam,
    };

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleChangeParam = createChangeHandler(setGroupId);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined ? "Create Param" : "Edit Param"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Group Name<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      paramPortalTarget={document.body}
                      styles={{
                        paramPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionParam}
                      value={getValueStatus(groupId, optionParam)}
                      placeholder="Select ..."
                      onChange={handleChangeParam}
                      isClearable={true}
                      isDisabled={id !== undefined}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Code<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setCode(e.target.value)}
                      value={code}
                      disabled={id !== undefined}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Ref Param</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setRefParam(e.target.value)}
                      value={refParam}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      {" "}
                      Display Order<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setDisplayOrder(e.target.value)}
                      value={displayOrder}
                      disabled={id !== undefined}
                    />{" "}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      {" "}
                      Value <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setValue(e.target.value)}
                      value={value}
                      disabled={id !== undefined}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </CardBody>
      </Card>
    </>
  );
};
